// extracted by mini-css-extract-plugin
export default {"emptyFieldValue":"index-module__emptyFieldValue--ZY0UR","linkedPullRequestContainer":"index-module__linkedPullRequestContainer--kuFNr"};